// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
  StyledMobileBoxLabel,
} from '../../utils/Styles/DataBoxStyles';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const EventsMobile = ({ events, tz, getEventTime, onEventClick }) => {
  return (
    <div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {events.map(event => (
        <StyledMobileBoxItem
          key={event.eventId}
          to={event.eventId}
          onClick={onEventClick}
        >
          <StyledMobileBoxLabel>{getEventTime(event, tz)}</StyledMobileBoxLabel>
          <StyledMobileBoxItemRow>{event.eventTitle}</StyledMobileBoxItemRow>
          <StyledMobileBoxItemRow>{event.eventName}</StyledMobileBoxItemRow>
        </StyledMobileBoxItem>
      ))}
    </div>
  );
};

export default EventsMobile;
